import api from "../api";

const endpoint = "/api/grupos";
const obterTodos = async () => {
  return new Promise((resolve, reject) => {
    return api
      .get(endpoint)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterTodosGruposDoUsuarioLogado = async (login) => {
  return new Promise((resolve, reject) => {
    return api
      .get(`${endpoint}/usuario/${login}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const obterPorId = async (id) => {
  return new Promise((resolve, reject) => {
    return api
      .get(`${endpoint}/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const cadastrar = async (setor) => {
  return new Promise((resolve, reject) => {
    return api
      .post(endpoint, setor)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const atualizar = async (id, setor) => {
  return new Promise((resolve, reject) => {
    return api
      .put(`${endpoint}/${id}`, setor)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

const excluir = async (id) => {
  return new Promise((resolve, reject) => {
    return api
      .delete(`${endpoint}/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default {
  obterTodos,
  obterTodosGruposDoUsuarioLogado,
  obterPorId,
  cadastrar,
  atualizar,
  excluir
};
